'use client';

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { initializeTheme } from '../../redux/slices/uiSlice';

export default function ThemeProvider({ children }) {
  const dispatch = useDispatch();

  useEffect(() => {
    // Initialize theme from localStorage or system preference
    dispatch(initializeTheme());
  }, [dispatch]);

  return <>{children}</>;
}
